<template>
  <div class="mall-specil-wrap">
    <!-- 规格label -->
    <div class="mall-specil-label" v-if="label && specilList && specilList.length">{{label}}</div>
    <div class="mall-specil-list" v-if="specilList && specilList.length">
      <!-- 规格btn -->
      <div
        v-for="(item, index) of specilList"
        :key="item.specilId"
        class="mall-specil-btn"
        :class="{'mall-specil-btn--active': value === item.specilId}" @click="handleSpecil(item, index)">
        <!-- 规格名称 -->
        <span class="mall-specil-btn__text">{{item.specilName}}</span>
        <!-- 库存提示 -->
        <i v-if="item.isShowStockReminderContent" class="mall-specil-btn__tip">{{item.stockReminderContent}}</i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MallSpecilOptions',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    specilList: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    handleSpecil(val, index) {
      this.$emit('input', val.specilId);
      this.$emit('onChange', { data: val, index });
    }
  }
};
</script>

<style lang="stylus" scoped>
.mall-specil-label {
  margin: 0 0 0.12rem;
  line-height: 20px;
  font-size: 0.14rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: bold;
  color: #6D6D80;
}
.mall-specil-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mall-specil-btn {
  position: relative;
  min-width: 48.35%;
  margin-bottom: 18px;
  text-align: center;
  line-height: 0.36rem;
  background: #F8F8FA;
  border-radius: 18px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #41414D;

  &.mall-specil-btn--active {
    color: #FF5F2E;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    background: rgb(253, 244, 241);

    .mall-specil-btn__tip {
      color: #fff;
      background: #F55549;
      &:before {
        background: #F55549;
      }
      &:after {
        background: rgb(253, 244, 241);
      }
    }
  }

  .mall-specil-btn__text {
    position: relative;
    z-index: 1;
    display: block;
    padding: 0.08rem 0.14rem;
    line-height: 0.2rem;
  }

  .mall-specil-btn__tip {
    position: absolute;
    right: 0;
    top: -0.08rem;
    height: 0.16rem;
    padding: 0 0.14rem 0 0.08rem;
    line-height: 0.16rem;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    font-style: normal;
    color: #FF5F2E;
    background: #FFE9E6;
    border-radius: 10px;
    border-top-right-radius: 0.14rem;
    border-bottom-right-radius: 0;
    &:before {
      position: absolute;
      right: 0;
      top: 0.16rem;
      content: " ";
      width: 0.13rem;
      height: 0.13rem;
      background: #FFE9E6;
    }
    &:after {
      position: absolute;
      right: 0;
      top: 0.16rem;
      content: " ";
      width: 0.25rem;
      height: 0.25rem;
      background: #F8F8FA;
      border-top-right-radius: 80%;
      border-bottom-right-radius: 80%;
    }
  }
}



</style>